import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from "../../config"; // Import API_URL from config
import { showToast } from '../../components/toast';
import LoadingSpinner from '../../components/LoadingSpinner';

const AddSitemap = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    pageName: '',
    pageUrl: '',
    productApp: '0' // Default to streetgains (0)
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form data
    if (!formData.pageName.trim()) {
      showToast.error('Please enter page name');
      return;
    }
    
    if (!formData.pageUrl.trim()) {
      showToast.error('Please enter page URL');
      return;
    }

    // Basic URL validation
    try {
      new URL(formData.pageUrl);
    } catch (error) {
      showToast.error('Please enter a valid URL');
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      
      const response = await axios.post(
        `${API_URL}siteMap/save`,
        {
          page_name: formData.pageName.trim(),
          page_url: formData.pageUrl.trim(),
          product_app: parseInt(formData.productApp) // 0 for streetgains, 1 for streetfolio
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.success) {
        showToast.success('Sitemap page added successfully');
        // Navigate back to sitemap list
        navigate('/Website/Sitemap');
      } else {
        const errorMessage = response.data?.message || 'Failed to add sitemap page';
        showToast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error adding sitemap page:', error);
      const errorMessage = error.response?.data?.message || 'Failed to add sitemap page. Please try again.';
      showToast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/Website/Sitemap');
  };

  return (
    <div className="page-container mt-5">
      {loading && <LoadingSpinner />}
      
      {/* Breadcrumb */}
      <div className="d-flex align-items-center mb-3">
        <Link to="/" className="text-primary text-decoration-none">
          <i className="fas fa-home me-1"></i> Home
        </Link>
        <span className="mx-2">/</span>
        <Link to="/Website/Sitemap" className="text-primary text-decoration-none">
          Manage Sitemap
        </Link>
        <span className="mx-2">/</span>
        <span>Add Page</span>
      </div>

      <div className="panel panel-default with-rounded-corner with-shadow p-10">
        <div className="panel-body">
          <h3 className="mb-4">Add Sitemap Page</h3>
          
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">
                  Page Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="pageName"
                  value={formData.pageName}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Enter Page Name"
                  disabled={loading}
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  Page URL <span className="text-danger">*</span>
                </label>
                <input
                  type="url"
                  name="pageUrl"
                  value={formData.pageUrl}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Enter Page URL (e.g., https://example.com/page)"
                  disabled={loading}
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  Sitemap Type <span className="text-danger">*</span>
                </label>
                <select
                  name="productApp"
                  value={formData.productApp}
                  onChange={handleInputChange}
                  className="form-control"
                  disabled={loading}
                  required
                >
                  <option value="0">Streetgains Sitemap</option>
                  <option value="1">Streetfolio Sitemap</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-2 mt-4">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Saving...
                  </>
                ) : (
                  'Submit'
                )}
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="btn btn-danger"
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Scroll to top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default AddSitemap;